import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
const offerItems = [{
  title: 'Guía Maestra "Sueño Profundo"',
  description: 'El sistema completo paso a paso para noches tranquilas',
  value: '$47',
  isMain: true
}, {
  title: 'BONO: Log de Seguimiento Diario',
  description: 'Rastrea el progreso de tu bebé día a día',
  value: '$15',
  isMain: false
}, {
  title: 'BONO: Guía de Siestas Perfectas',
  description: 'Optimiza las siestas para mejores noches',
  value: '$19',
  isMain: false
}];
export function OfferSection() {
  return <section id="oferta" className="relative bg-navy-800 py-20 px-4 overflow-hidden" data-id="element-128">
      <div className="section-divider absolute top-0 left-0 right-0" data-id="element-129" />

      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full opacity-10 pointer-events-none blur-3xl" style={{
      background: 'radial-gradient(circle, #c9a84c, transparent)'
    }} data-id="element-130" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-12" data-id="element-132">
          <p className="font-lato text-gold-400 text-sm font-bold tracking-widest uppercase mb-3" data-id="element-133">
            La Oferta
          </p>
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-cream leading-tight" data-id="element-134">
            Todo lo que Recibes <span className="gold-gradient-text" data-id="element-135">Hoy</span>
          </h2>
        </motion.div>

        {/* Offer stack */}
        <div className="space-y-4 mb-10" data-id="element-136">
          {offerItems.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.15
        }} className={`flex items-center justify-between p-5 rounded-2xl border ${item.isMain ? 'border-gold-500/50 bg-gold-500/10' : 'border-gold-500/20 bg-navy-900/60'}`} data-id="element-137">
              <div className="flex items-start gap-4" data-id="element-138">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${item.isMain ? 'gold-gradient-bg' : 'bg-gold-500/20'}`} data-id="element-139">
                  <Check size={14} className={item.isMain ? 'text-navy-900' : 'text-gold-400'} data-id="element-140" />
                </div>
                <div data-id="element-141">
                  <p className={`font-lato font-bold ${item.isMain ? 'text-cream' : 'text-cream/90'}`} data-id="element-142">
                    {item.title}
                  </p>
                  <p className="font-lato text-cream/50 text-sm mt-0.5" data-id="element-143">
                    {item.description}
                  </p>
                </div>
              </div>
              <div className="text-right flex-shrink-0 ml-4" data-id="element-144">
                <p className="font-lato text-cream/40 text-sm line-through" data-id="element-145">
                  Valor {item.value}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Price box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} id="precio" className="rounded-3xl border border-gold-500/50 p-10 text-center" style={{
        background: 'linear-gradient(135deg, rgba(201,168,76,0.12), rgba(10,22,40,0.95))'
      }} data-id="element-146">
          <div className="flex justify-center gap-1 mb-4" data-id="element-147">
            {[...Array(5)].map((_, i) => <Star key={i} size={16} className="text-gold-400 fill-gold-400" data-id="element-148" />)}
          </div>

          <p className="font-lato text-cream/60 text-lg mb-1" data-id="element-149">
            Valor total: <span className="line-through" data-id="element-150">$81 USD</span>
          </p>
          <p className="font-lato text-cream/80 text-lg mb-3" data-id="element-151">Hoy por solo:</p>
          <p className="font-playfair font-black gold-gradient-text mb-2 text-[72px]" data-id="element-152">
            $6.39
          </p>
          <p className="font-lato text-gold-400 text-lg font-bold mb-8" data-id="element-153">
            USD · Acceso Inmediato · Digital · En Español
          </p>

          <a href="https://novadigitalventures.com/cart/42535353811015:1" onClick={() => {
          if (typeof (window as any).fbq === 'function') {
            ;
            (window as any).fbq('track', 'AddToCart', {
              value: 6.39,
              currency: 'USD',
              content_name: 'Sueño Profundo'
            });
          }
        }} className="cta-glow gold-gradient-bg text-navy-900 font-lato font-black text-lg md:text-xl px-10 py-5 rounded-full uppercase tracking-wide hover:scale-105 transition-transform duration-200 cursor-pointer w-full max-w-md inline-block text-center" data-id="element-154">
            SÍ, QUIERO RECUPERAR MIS NOCHES →
          </a>

          <div className="flex flex-wrap items-center justify-center gap-4 mt-5 text-cream/50 font-lato text-sm" data-id="element-155">
            {['Pago seguro', 'Acceso en 2 minutos', 'Garantía total de 7 días'].map(item => <span key={item} className="flex items-center gap-1" data-id="element-156">
                <Check size={13} className="text-gold-400" data-id="element-157" />
                {item}
              </span>)}
          </div>
        </motion.div>
      </div>

      <div className="section-divider absolute bottom-0 left-0 right-0" data-id="element-158" />
    </section>;
}